export function getToken(): string | boolean {
  return localStorage.getItem("ACCESS_TOKEN") ?? false;
}

export function setToken(token: string): void {
  localStorage.setItem("ACCESS_TOKEN", token);
}

export function removeToken(): void {
  localStorage.removeItem("ACCESS_TOKEN");
  localStorage.removeItem("ACCESS_INFO");
  localStorage.removeItem("ACCESS_AUTH");
  localStorage.removeItem("ACCESS_BACK_LIST");
  localStorage.removeItem("ACTIVE_ROUTE");

  sessionStorage.clear();
}

export function setActiveName(info: string): void {
  localStorage.setItem("ACTIVE_ROUTE", info);
}

export function getActiveName(): any | boolean {
  return localStorage.getItem("ACTIVE_ROUTE") ?? false;
}

export function setPassword(info: string): void {
  localStorage.setItem("ACCESS_PASSWORD", info);
}

export function getPassword(): any | boolean {
  return localStorage.getItem("ACCESS_PASSWORD") ?? false;
}

export function setUserInfo(info: string): void {
  localStorage.setItem("ACCESS_INFO", info);
}

export function getUserInfo(): any | boolean {
  return localStorage.getItem("ACCESS_INFO") ?? false;
}

export function setAuth(info: string): void {
  localStorage.setItem("ACCESS_AUTH", info);
}

export function getAuth(): any | boolean {
  return localStorage.getItem("ACCESS_AUTH") ?? false;
}

export function setBackList(info: string): void {
  sessionStorage.setItem("ACCESS_BACK_LIST", info);
}

export function getBackList(): any | boolean {
  return sessionStorage.getItem("ACCESS_BACK_LIST") ?? false;
}

export function setUtilitesBackList(info: string): void {
  sessionStorage.setItem("UTILITES_ACCESS_BACK_LIST", info);
}

export function getUtilitesBackList(): any | boolean {
  return sessionStorage.getItem("UTILITES_ACCESS_BACK_LIST") ?? false;
}

export function setH5DetailBack(info: string): void {
  sessionStorage.setItem("H5_DETAIL_BACK", info);
}

export function getH5DetailBack(): any | boolean {
  return sessionStorage.getItem("H5_DETAIL_BACK") ?? false;
}

export function removeH5DetailBack(): any | boolean {
  return sessionStorage.removeItem("H5_DETAIL_BACK");
}

export function setWebSocket(info: string): void {
  sessionStorage.setItem("WEB_SOCKET", info);
}

export function getWebSocket(): any | boolean {
  return sessionStorage.getItem("WEB_SOCKET") ?? false;
}

export function removeWebSocket(): any | boolean {
  return sessionStorage.removeItem("WEB_SOCKET");
}
